<template>
  <div>
    <nav-bar />
    <div class="container">
      <div class="user-box">
        <user-menu />
        <div class="user-content">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <foot />
  </div>
</template>

<script>
import NavBar from '@/components/navbar/index.vue'
import Foot from '@/components/foot/index.vue'
import UserMenu from './components/userMenu.vue'
export default {
  components: {
    NavBar,
    Foot,
    UserMenu
  },
}
</script>

<style lang="scss" scoped>
.user-box {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .user-content {
    width: 870px;
  }
}

</style>